// src/components/Layout.js
import React, { useContext } from "react";
import { Layout, Select, Button } from "antd";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../LanguageContext";

const { Header, Content, Footer } = Layout;

const AppLayout = ({ children }) => {
  const { language, setLanguage, translations } = useContext(LanguageContext);
  const navigate = useNavigate();
  
  
  const handleClick = () => {
    navigate('/');
  };
  return (
    <Layout
      style={{
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        overflow: "hidden"
      }}
    >
      <Header
        style={{
          background: "#001529",
          color: "#fff",
          textAlign: "center",
          fontSize: "18px",
          display: "flex",
          justifyContent: "space-between", // Admin butonunu ve yazıyı ayırmak için
          alignItems: "center",
          padding: "0 50px" // Header'a iç boşluk ekliyoruz
        }}
      >
        {/* "Octoopi" metni sol tarafta */}
        <div 
      style={{ fontSize: "20px", cursor: "pointer" }} 
      onClick={handleClick}
    >
      {translations[language].layoutTitle}
    </div>

        {/* Admin giriş butonu, sağda ortalanmış */}
        <Button
          type="primary"
          style={{
            marginLeft: "auto", // Butonu sağa itiyoruz
            marginRight: "20px" // Sağdan mesafe bırakıyoruz
          }}
          onClick={() => navigate("/login")}
        >
           Login
        </Button>

        {/* Dil seçimi */}
        <Select
          defaultValue={language}
          style={{
            width: 120,
          }}
          onChange={(value) => setLanguage(value)}
        >
          <Select.Option value="tr">Türkçe</Select.Option>
          <Select.Option value="en">English</Select.Option>
          <Select.Option value="de">Deutsch</Select.Option>
        </Select>

        {/* Yardım butonu, sağda Admin butonunun yanında */}
        <Button
          type="default"
          style={{
            marginLeft: "10px", // Yardım butonunu Admin butonundan ayırıyoruz
          }}
          onClick={() => navigate("/support")}
        >
          {translations[language].howUsing}
        </Button>

        <Button
          type="default"
          style={{
            marginLeft: "10px", // Yardım butonunu Admin butonundan ayırıyoruz
          }}
          onClick={() => navigate("/userform")}
        >
          Hesap Oluştur
        </Button>
      </Header>

      <Content
        style={{
          padding: "20px",
          flex: 1,
          overflow: "auto"
        }}
      >
        {children}
      </Content>

      <Footer style={{ textAlign: "center",  cursor: "pointer"}}>
  © 2026  <a href="http://octoopi.com/" target="_blank" rel="noopener noreferrer">Octoopi </a>  & by  <a href="https://mertech.com.tr/" target="_blank" rel="noopener noreferrer">Mertech Electronics</a>
</Footer>

    </Layout>
  );
};

export default AppLayout;
